import axiosClient from '@/api/axiosClient';
import {
  API_GET_FREE_PLAY,
  API_GET_SOLO_MODE,
  API_GET_CHARGE_HISTORY,
  API_GET_REGISTER_CANCEL,
  API_GET_MULTI_MODE,
  API_GET_USER_KEY,
} from '@/config/paths/API_PATH';

async function getHistorySoloMode(payload) {
  const { data } = await axiosClient.get(API_GET_SOLO_MODE, {
    params: payload,
  });

  return data;
}

async function getHistoryMultipleMode(payload) {
  const { data } = await axiosClient.get(API_GET_MULTI_MODE, {
    params: payload,
  });

  return data;
}

async function getFreePlay(payload) {
  const { data } = await axiosClient.get(API_GET_FREE_PLAY, {
    params: payload,
  });

  return data;
}

async function getFreePlayOverview(payload) {
  const { data } = await axiosClient.get(`${API_GET_FREE_PLAY}/detail`, {
    params: payload,
  });

  return data;
}

async function getChargeHistory(payload) {
  const { data } = await axiosClient.get(API_GET_CHARGE_HISTORY, {
    params: payload,
  });

  return data;
}

async function getRegisterCancelHistory(payload) {
  const { data } = await axiosClient.get(API_GET_REGISTER_CANCEL, {
    params: payload,
  });

  return data;
}

async function getUserKeys(payload) {
  const { data } = await axiosClient.get(API_GET_USER_KEY, {
    params: payload,
  });

  return data;
}

export {
  getHistorySoloMode,
  getHistoryMultipleMode,
  getFreePlay,
  getFreePlayOverview,
  getChargeHistory,
  getRegisterCancelHistory,
  getUserKeys,
};
